/**
 * @ Author: Your name
 * @ Create Time: 2023-10-21 15:40:38
 * @ Modified by: Your name
 * @ Modified time: 2025-10-16 10:11:28
 * @ Description: 计提接口
 */

import request from 'server'

// 规则列表
export const provisionRuleList = (data: Object) => {
  return request({
    url: `/customer/provisionRule/list`,
    method: 'post',
    data,
  })
}
// 规则详情
export const provisionRuleDetail = (id: string) => {
  return request({
    url: `/customer/provisionRule/detail`,
    method: 'post',
    data: { id },
  })
}

// 规则保存
export const provisionRuleSave = (data: IprovisionRuleSubmitForm) => {
  return request({
    url: `/customer/provisionRule/save`,
    method: 'post',
    data,
  })
}

// 计提明细列表

export const provisionRecordList = (data: IprovisionInfoSearchListModel) => {
  return request({
    url: `/provision/provisionRecordV2/provisionRecordList/v2`,
    method: 'post',
    data,
  })
}

// 计提查询
export const provisionLockInfo = (lockTime: string, lockType: number) => {
  return request({
    url: `/provision/provisionLock/lockInfo`,
    method: 'post',
    data: { lockTime, lockType },
  })
}

// 计提数据锁定 取消
export const provisionLock = (data: {
  lockTime: string
  lockStatus: number
}) => {
  return request({
    url: `/provision/provisionLock/lock`,
    method: 'post',
    data,
  })
}
//
export const provisionRecordForOrder = (data: { id: string }) => {
  return request({
    url: `/recruitment/provisionRecord/provisionRecordForOrder`,
    method: 'post',
    data,
  })
}

// 经理计提列表
export const getManagerProvisionRuleList = (data: Object) => {
  return request({
    url: `/customer/provisionRule/managerRule/list`,
    method: 'post',
    data,
  })
}
// 经理计提详情
export const getManagerProvisionRuleDetail = (data: {
  ruleMonth: string
  ruleYear: string
}) => {
  return request({
    url: `/customer/provisionRule/managerRule/detail`,
    method: 'post',
    data,
  })
}
// 是否存在经理计提配置
export const getManagerRuleExist = (data: {
  ruleMonth: string
  ruleYear: string
}) => {
  return request({
    url: `/customer/provisionRule/managerRuleExist`,
    method: 'post',
    data,
  })
}
// 经理计提保存
export const saveManagerProvisionRuleDetail = (
  data: ImanagerRuleDetailModel,
) => {
  return request({
    url: `/customer/provisionRule/managerRule/saveOrUpdate`,
    method: 'post',
    data,
  })
}

// 查询月末在职
export const shopOnJobNumber = (data: {
  ruleMonth: string
  ruleYear: string
}) => {
  return request({
    url: `/recruitment/provisionRecord/shopOnJobNumber`,
    method: 'post',
    data,
  })
}

// 员工计提-批量保存配置
export const batchRuleSave = (data: any) => {
  return request({
    url: `/customer/provisionRule/batchRuleSave`,
    method: 'post',
    data,
  })
}
// 员工计提-批量保存配置记录
export const batchRuleHistory = (data: any) => {
  return request({
    url: `/customer/provisionRule/batchRuleHistory`,
    method: 'post',
    data,
  })
}
// 员工计提-查询所有集体类别以及门店数
export const queryShopCategoryAndShopCount = () => {
  return request({
    url: `/system/sysShopCategoryProvision/queryShopCategoryAndShopCount`,
    method: 'post',
    data: {},
  })
}

// 安置计提规则列表
export const getProvisionRuleList = (data: Object) => {
  return request({
    url: `/provision/provisionRule/arrange/rule/list`,
    method: 'post',
    data,
  })
}

// 安置计提配置-门店安置状态更新
export const statusConfigSave = (data: Object) => {
  return request({
    url: `/provision/provisionRule/arrange/statusConfig/save`,
    method: 'post',
    data,
  })
}

// 安置计提安置员配置查询
export const getProvisionRuleDetail = (data: any) => {
  return request({
    url: `/provision/provisionRule/arrange/config/detail`,
    method: 'post',
    data,
  })
}
// 安置计提安置员配置提交
export const saveProvisionRuleDetail = (data: any) => {
  return request({
    url: `/provision/provisionRule/arrange/config/saveOrUpdate`,
    method: 'post',
    data,
  })
}
// 安置计提数据锁定
export const provisionLockArrange = (data: any) => {
  return request({
    url: `/provision/provisionRule/arrange/lock`,
    method: 'post',
    data,
  })
}

// 期初计提列表
export const getOpeningProvisionRuleList = () => {
  return request({
    url: `/provision/provisionRule/start/rule/list`,
    method: 'post',
    data: {},
  })
}

// 期初计提详情
export const getOpeningProvisionRuleDetail = (data: {
  ruleMonth: string
  ruleYear: string
}) => {
  return request({
    url: `/customer/provisionRule/startRule/detail`,
    method: 'post',
    data,
  })
}

// 期初计提保存
export const saveOpeningProvisionRuleDetail = (
  data: IprovisionOpeningRuleList,
) => {
  return request({
    url: `/customer/provisionRule/startRule/saveOrUpdate`,
    method: 'post',
    data,
  })
}
// 期初计提数据-门店及在职人员相关人数
export const getOpeningProvisionShopInfo = (data: any) => {
  return request({
    url: `/provision/provisionRule/shopAndOnJobInfo`,
    method: 'post',
    data,
  })
}

// 期初计提数据配置
export const saveProvisionConfig = (data: any) => {
  return request({
    url: `/provision/provisionRule/start/rule/saveOrUpdate`,
    method: 'post',
    data,
  })
}
// 期初计提数据详情
export const getProvisionConfigDetail = (data: any) => {
  return request({
    url: `/provision/provisionRule/start/rule/detail`,
    method: 'post',
    data,
  })
}

// 导入离职员工
export const userRoleImport = (data = {}) => {
  return request({
    url: `/system/user/downloadQuitTemplate`,
    method: 'post',
    data,
  })
}

/**
 * 计提预警面板
 */
// 面板总览查询
export const provisionWarningAll = (data: any) => {
  return request({
    url: `/provision/provisionWarning/all`,
    method: 'post',
    data,
  })
}
// 确认异常接口
export const provisionWarningConfirm = (data: any) => {
  return request({
    url: `/provision/provisionWarning/warningConfirm`,
    method: 'post',
    data,
  })
}

//  组织架构变动
export const orgDeptChangeList = (data: any) => {
  return request({
    url: `/system/hr/orgDeptChange/list`,
    method: 'post',
    data,
  })
}

//  岗位变动
export const positionChangeList = (data: any) => {
  return request({
    url: `/system/hr/positionChange/list`,
    method: 'post',
    data,
  })
}

// 未配置计提角色表
export const getProvisionRoleNotConfig = (data: any) => {
  return request({
    url: `/system/recruit/getProvisionRoleNotConfig/list  `,
    method: 'post',
    data,
  })
}

// 岗位角色差异表
export const getProvisionRoleDiff = (data: any) => {
  return request({
    url: `/system/recruit/getProvisionRoleDiff/list  `,
    method: 'post',
    data,
  })
}

// 未配置安置计提门店
export const getUnArrangeShop = (data: any) => {
  return request({
    url: `/provision/provisionWarning/getUnArrangeShop/list`,
    method: 'post',
    data,
  })
}
// 提醒门店配置
export const unArrangeShopNotice = (data: any) => {
  return request({
    url: `/provision/provisionWarning/unArrangeShop/notice`,
    method: 'post',
    data,
  })
}

// 提醒门店配置全部
export const unArrangeShopNoticeAll = (data: any) => {
  return request({
    url: `/provision/provisionWarning/unArrangeShop/noticeAll`,
    method: 'post',
    data,
  })
}

// 定制规则核验计提明细表
export const customRuleProvisionList = (data: any) => {
  return request({
    url: `/provision/provisionWarning/customRule/provisionList`,
    method: 'post',
    data,
  })
}

// 门店等级变动记录
export const getShopCategoryChangeList = (data: any) => {
  return request({
    url: `/system/recruit/getShopCategoryChange/list`,
    method: 'post',
    data,
  })
}
//计提角色变动记录
export const getProvisionRoleChangeList = (data: any) => {
  return request({
    url: `/system/recruit/getProvisionRoleChange/list`,
    method: 'post',
    data,
  })
}
